module.exports = __webpack_public_path__ + "static/media/4. In DM with agents.700d88dc.svg";